import { render, staticRenderFns } from "./PageActivities.vue?vue&type=template&id=3c7d7e61&scoped=true&"
import script from "./PageActivities.vue?vue&type=script&lang=ts&"
export * from "./PageActivities.vue?vue&type=script&lang=ts&"
import style0 from "./PageActivities.vue?vue&type=style&index=0&id=3c7d7e61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d7e61",
  null
  
)

export default component.exports